import { ReactElement, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, makeStyles } from '@material-ui/core';
import { OrganizationDeliveryPoint } from '../../types/organization.type';

type Props = {
  deliveryPoint: OrganizationDeliveryPoint;
  onConfirm: () => void;
  trigger: (handleOpen: () => void) => ReactElement;
};

const useStyles = makeStyles({
  root: {
    '& > .MuiDialog-container': {
      '& > .MuiPaper-root': {
        minWidth: '300px',
      },
    },
  },
});

export default function RemoveDeliveryPointDialog({ deliveryPoint, onConfirm, trigger }: Props) {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <>
      {trigger(handleOpen)}
      <Dialog open={open} onClose={handleClose} className={classes.root}>
        <DialogContent>
          <DialogContentText>
            Êtes-vous sûr de vouloir retirer le point de livraison {deliveryPoint.name} de l&apos;organisation ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          <Button onClick={handleConfirm} color="secondary" variant="contained">
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
